// extracted by mini-css-extract-plugin
export default {"root":"MissionStatementGrid-module--root--ccaf0","statement":"MissionStatementGrid-module--statement--05538","imgContainer":"MissionStatementGrid-module--imgContainer--63e8d"};